import React, { useEffect, useState } from 'react'
import ReactQuill from 'react-quill';
import qs from 'qs';
import axios from '@/utils/axios'

import './styles.css';

const Notes = ({notableId, notableType, ownerId, ownerType, helpDocLink, helpDocText}) => {
  const [notes, setNotes] = useState('');
  const [loading, setLoading] = useState(true);

  const handleSave = () => {
    const payload = {body: notes};
    if(ownerId) payload.owner_id = ownerId;
    if(ownerType) payload.owner_type = ownerType;

    axios.put(`/notes/${notableType}/${notableId}.json`, qs.stringify(payload)).then(res => {
      console.log(res.data);
    });
  };

  useEffect(() => {
    const payload = {};
    if(ownerId) payload.owner_id = ownerId;
    if(ownerType) payload.owner_type = ownerType;

    axios.get(`/notes/${notableType}/${notableId}.json`, {params: payload}).then(res => {
      setNotes(res.data.note);
      setLoading(false)
    });
  }, []);

  return (
    <div className="card note-editor">
      <div className="card-header d-flex align-items-center justify-content-between">
        <span>
          {!!ownerType && ownerType == "Tournament" ? (
            <>Edit Shared Private Notes</>
          ) : (
            <>Edit Notes</>
          )}
        </span>
        {!!helpDocLink && (
          <a href={helpDocLink} target="_blank" className="ml-auto">{helpDocText || "Learn More"}</a>
        )}
      </div>
      <div className="card-body p-0">
        {!!loading ? (
          <i className="fas fa-spin fa-spinner-third"></i>
        ) : (
          <ReactQuill theme="snow" defaultValue={notes} onChange={setNotes} />
        )}
        
      </div>
      <div className="card-footer">
        <button className="btn btn-primary" onClick={handleSave}>
          Save Changes
        </button>
      </div>
    </div>
  );
};

export default Notes;